// Constants
import { CampaignTypesConstants } from "../../constants/GeneralConstants";

// Components
import { PlainDropdown } from "../dropdown/Dropdown";

// Campaign Type Selection Card
export default function CampaignTypeSelectionCard({
  campaignTypeData = {},
  campaignType,
  setCampaignType,
  campaignId,
}) {
  const { step, title, message } = campaignTypeData || {};

  return (
    <div className="card shadow mb-4 mt-3">
      <div className="d-flex justify-content-between">
        <div className="card-content">
          <p className="card__step">{step}</p>
          <p className="card__title">{title}</p>
          <p className="card__message">{message}</p>
        </div>
        <div className="card-action">
          <PlainDropdown
            items={CampaignTypesConstants}
            className="btn shadow-none rounded-lg border border-primary mt-4 btn-action px-3"
            placeHolder="Select Campaign Type"
            onItemSelect={setCampaignType}
            dropMenuClassName="dropdown-fixed-height"
            selectedId={campaignType} // existing campaignType for campaign
            disabled={campaignId}
            isFirstItemSelectable={true}
          />

          {/* if uploading excel to existing campaign then froze the campaignType selection */}
          {campaignId && (
            <p className="text-primary my-2 font-weight-bold text-center">
              CAMPAIGN TYPE FROZEN
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
